import { FeatureFlag } from '../FeatureFlag';

export const enableLabRevenueAnalytics = new FeatureFlag({
    key: 'enable-lab-revenue-analytics',
    createdOn: '2026-07-07',
    defaultValue: false,
});
